/** Operational work location for employees (`staff.work_area`). Not RBAC. */
export const STAFF_WORK_AREAS = [
  { value: 'floor', label: 'Floor' },
  { value: 'backoffice', label: 'Back office' },
  { value: 'both', label: 'Floor & back office' },
]

export function staffWorkAreaLabel(value) {
  const row = STAFF_WORK_AREAS.find((x) => x.value === value)
  return row ? row.label : value || '—'
}
